export interface IStepperBounds {
  min: number;
  max: number;
  step: number;
}

/** "1.000" / "12,500": thousands on es-AR / pt-BR keypads, not decimals. */
const GROUPED_INTEGER = /^\d{1,3}([.,]\d{3})+$/;

/** Digits of the app's non-Latin locales (ar, ur, bn, hi keypads), 0-9 each. */
const NATIVE_DIGITS = ['٠١٢٣٤٥٦٧٨٩', '۰۱۲۳۴۵۶۷۸۹', '০১২৩৪৫৬৭৮৯', '०१२३४५६७८९'];
const NATIVE_DIGIT = new RegExp(`[${NATIVE_DIGITS.join('')}]`, 'g');

function toAsciiDigits(text: string): string {
  return text.replace(NATIVE_DIGIT, (digit) => {
    const set = NATIVE_DIGITS.find((digits) => digits.includes(digit));
    return set ? String(set.indexOf(digit)) : digit;
  });
}

/**
 * Turns typed text into a value the stepper can hold: clamped to the bounds
 * and snapped to the step grid. Returns null when the text is not a number.
 */
export function normalizeStepperValue(
  raw: string,
  { min, max, step }: IStepperBounds
): number | null {
  const trimmed = toAsciiDigits(raw.trim());
  const text = GROUPED_INTEGER.test(trimmed)
    ? trimmed.replace(/[.,]/g, '')
    : trimmed.replace(',', '.');
  if (!text) return null;
  const parsed = Number(text);
  if (!Number.isFinite(parsed)) return null;
  const clamped = Math.min(max, Math.max(min, parsed));
  const size = Number.isFinite(step) && step > 0 ? step : 1;
  const snapped = min + Math.round((clamped - min) / size) * size;
  return Math.min(max, Math.max(min, snapped));
}
